export const loadWebFonts = () => {
  if (document.getElementById('slide-web-fonts')) {
    return document.fonts ? document.fonts.ready : Promise.resolve();
  }

  // Create the font link
  const link = document.createElement('link');
  link.id = 'slide-web-fonts';
  link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Poppins:wght@300;400;500;600;700;800;900&family=Montserrat:wght@300;400;500;600;700;800;900&family=Playfair+Display:wght@300;400;500;600;700;800&family=Orbitron:wght@400;500;600;700;800;900&family=Rajdhani:wght@300;400;500;600;700&display=swap';
  link.rel = 'stylesheet';
  
  return new Promise((resolve) => {
    link.onload = () => {
      if (document.fonts) {
        // Wait for ALL fonts to be ready
        document.fonts.ready.then(() => {
          // Extra delay for canvas rendering
          setTimeout(() => {
            resolve();
          }, 500);
        });
      } else {
        // Fallback if FontFace API not available
        setTimeout(() => {
          resolve();
        }, 1500);
      }
    };
    
    link.onerror = () => {
      resolve(); // Still resolve to not block the app
    };
    
    document.head.appendChild(link);
  });
};